var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "nav nav-pills nav-justified margin-bottom-4x" },
    [
      _c(
        "li",
        {
          directives: [
            {
              name: "hasPermits",
              rawName: "v-hasPermits:allow",
              value: { id: _vm.locId, permits: ["location_user"] },
              expression: "{id: locId, permits: ['location_user']}",
              arg: "allow"
            }
          ],
          class: { active: _vm.$route.name == "locations.guestManagement" },
          attrs: { role: "presentation" }
        },
        [
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: "locations.guestManagement",
                  params: {
                    id: _vm.$route.params.id
                  }
                }
              }
            },
            [_vm._v("\n      Guest Management\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "li",
        {
          directives: [
            {
              name: "hasPermits",
              rawName: "v-hasPermits:allow",
              value: { id: _vm.locId, permits: ["location_user"] },
              expression: "{id: locId, permits: ['location_user']}",
              arg: "allow"
            }
          ],
          class: {
            active: _vm.$route.name == "locations.guestManagement.inHouseReport"
          },
          attrs: { role: "presentation" }
        },
        [
          _c(
            "router-link",
            {
              attrs: {
                to: {
                  name: "locations.guestManagement.inHouseReport",
                  params: {
                    id: _vm.$route.params.id
                  }
                }
              }
            },
            [_vm._v("\n      In House Report\n    ")]
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2cc71e2a", { render: render, staticRenderFns: staticRenderFns })
  }
}